var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "wizard-content", attrs: { id: "template-wizard" } },
    [
      _c(
        "sc-card",
        { staticClass: "wizard-content__card" },
        [
          _c(
            "template",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _vm.stepActive > 1
                ? _c("billing-template-summary", {
                    attrs: {
                      logisticProviderId:
                        _vm.formContent.lpAndDmInfo.logistic_provider_id,
                      templateName: _vm.formContent.name,
                      templateRowNumber: _vm.formContent.rowNumber
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "wizard-content__steps" },
                [
                  _c("new-billing-template-step-1", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.stepActive === 1,
                        expression: "stepActive === 1"
                      }
                    ],
                    on: { onNextStep: _vm.nextStep }
                  }),
                  _vm._v(" "),
                  _c("new-billing-template-step-2", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.stepActive === 2,
                        expression: "stepActive === 2"
                      }
                    ],
                    on: { onNextStep: _vm.nextStep, onPrevStep: _vm.prevStep }
                  }),
                  _vm._v(" "),
                  _c("new-billing-template-step-3", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.stepActive === 3,
                        expression: "stepActive === 3"
                      }
                    ],
                    attrs: {
                      previewMap: _vm.previewMap,
                      previewMapIsEmpty: _vm.previewMapIsEmpty
                    },
                    on: { onNextStep: _vm.nextStep, onPrevStep: _vm.prevStep }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "wizard-content__loading" },
                [
                  _c("new-billing-template-saving-modal", {
                    on: {
                      onOverwriteCancel: function($event) {
                        _vm.stepActive = 1
                      },
                      onOverwriteConfirm: function($event) {
                        _vm.saveBillingTemplate(
                          Object.assign({}, _vm.formContent, {
                            overwrite: true
                          })
                        )
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09aa639d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09aa639d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/pages/templates/components/NewBillingTemplateWizard.vue
// module id = null
// module chunks = 